import { Route } from "@dashboard/components/Router";
import { WindowTitle } from "@dashboard/components/WindowTitle";
import { sectionNames } from "@dashboard/intl";
import { parse as parseQs } from "qs";
import { useIntl } from "react-intl";
import { type RouteComponentProps, Switch } from "react-router-dom";

import {
  atticApiKeyAddPath,
  atticApiKeyListPath,
  type AtticApiKeyListUrlQueryParams,
  atticApiKeyPath,
} from "./urls";
import AtticApiKeyCreateView from "./views/AtticApiKeyCreate";
import AtticApiKeyDetailsView from "./views/AtticApiKeyDetails";
import AtticApiKeyListView from "./views/AtticApiKeyList";

const ApiKeyList = ({ location }: RouteComponentProps) => {
  const params = parseQs(location.search.replace(/^\?/, "")) as AtticApiKeyListUrlQueryParams;

  return <AtticApiKeyListView params={params} />;
};

const ApiKeyDetails = ({ match }: RouteComponentProps<{ id: string }>) => (
  <AtticApiKeyDetailsView id={decodeURIComponent(match.params.id)} />
);

// Behind MANAGE_APPS: the SectionRoute in src/index.tsx gates the whole section.
const Component = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.atticApiKeys)} />
      <Switch>
        <Route exact path={atticApiKeyListPath} component={ApiKeyList} />
        <Route exact path={atticApiKeyAddPath} component={AtticApiKeyCreateView} />
        <Route exact path={atticApiKeyPath(":id")} component={ApiKeyDetails} />
      </Switch>
    </>
  );
};

export default Component;
